import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DoctorAuthPage from './pages/DoctorAuthPage';

// Импорт страниц
import LandingPage from './pages/LandingPage';
import ScalesPage from './pages/ScalesPage';
import TestRunnerPage from './pages/TestRunnerPage';
import PatientRegistrationPage from './pages/PatientRegistrationPage'; 
import ExercisesPage from './pages/ExercisesPage';
import ExerciseRunnerPage from './pages/ExerciseRunnerPage';
import FullMetricsPage from './pages/FullMetricsPage';
import MetricsFaceAsymmetryPage from './pages/MetricsFaceAsymmetryPage';
import PatientCabinetPage from './pages/PatientCabinetPage';
import DoctorCabinetPage from './pages/DoctorCabinetPage';
import TestStubPage from './pages/TestStubPage';
import ExercisesStubPage from './pages/ExercisesStubPage';
import TrainerSessionPage from './pages/TrainerSessionPage';
import VisualPerceptionPage from './pages/VisualPerceptionPage';
import RetellPage from './pages/RetellPage';
import SchultePage from './pages/SchultePage';

export default function App() {
  return (
    <Routes>
  {/* Главная страница */}
  <Route path="/" element={<LandingPage />} />

  {/* Вход/регистрация врача — как было, не трогаем */}
  <Route path="/login" element={<DoctorAuthPage />} />
  <Route path="/doctor" element={<DoctorAuthPage />} />

  {/* Кабинет врача — НОВЫЙ (из демо), путь тот же */}
  <Route path="/doctor/dashboard" element={<DoctorCabinetPage />} />

  {/* Шкалы врача — ваши */}
  <Route path="/scales" element={<ScalesPage />} />
  <Route path="/test/:scaleId" element={<TestRunnerPage />} />

  {/* Пациент */}
  <Route path="/patient/register" element={<PatientRegistrationPage />} />
  {/* ЛК пациента — НОВЫЙ (из демо), путь тот же */}
  <Route path="/patient" element={<PatientCabinetPage />} />

  {/* Тренажёры — ваши */}
  <Route path="/exercises" element={<ExercisesPage />} />
  <Route path="/exercise/:exerciseId" element={<ExerciseRunnerPage />} />
  <Route path="/trainer" element={<TrainerSessionPage />} />
  <Route path="/visual" element={<VisualPerceptionPage />} />
  <Route path="/retell" element={<RetellPage />} />
  <Route path="/schulte" element={<SchultePage />} />

  {/* Демо: покадровые метрики одной CV-сессии */}
  <Route path="/demo/full-metrics" element={<FullMetricsPage />} />
  <Route path="/demo/metrics-face-asymmetry" element={<MetricsFaceAsymmetryPage />} />
</Routes>
  );
}